import { takeEvery, fork, put, all, call, select } from 'redux-saga/effects';
import {
  GET_POS_INTEGRATIONS,
  GET_POS_INTEGRATIONS_LIST,
  ADD_POS_INTEGRATION,
  DELETE_POS_INTEGRATION,
  EDIT_POS_INTEGRATION,
  UPDATE_POS_INTEGRATION,
} from './actionTypes';
import {
  setPosIntegrationsList,
  setPosIntegrations,
  emptyPosIntegration,
  setPosIntegration,
  apiError,
  getPosIntegrations as fetchPosIntegrations,
  setPosIntegrationFilter
} from './actions';
import { httpDelete, httpGet, httpPost, httpPut } from '../../utils/http';
import { POS_INTEGRATIONS_ENDPOINT } from '../../config/endPoints';
import { successToaster, errorToaster } from "../../components/Common/Toaster";

function* getPosIntegrations() {
  try {
    const posIntegrationState = yield select(getPosIntegration);
    let URL = POS_INTEGRATIONS_ENDPOINT;
    URL += `?offSet=${posIntegrationState.filter.offSet}`;
    URL += `&limit=${posIntegrationState.filter.limit}`;
    URL += `&query=${posIntegrationState.filter.query}`;

    const res = yield httpGet(URL);

    if (res.status !== 200) {
      yield put(apiError(res.data.error));
      return false;
    }

    yield put(setPosIntegrations(res.data.records));
    yield put(
      setPosIntegrationFilter({
        field: 'pages',
        value: res.data.pages,
      })
    );
  } catch (error) {
    yield put(apiError(error));
  }
}

function* getPosIntegrationsList() {
  try {
    let URL = `${POS_INTEGRATIONS_ENDPOINT}/get/list`;
    const res = yield httpGet(URL);

    if (res.status !== 200) {
      yield put(apiError(res.data.error));
      return false;
    }

    yield put(setPosIntegrationsList(res.data));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* addPosIntegration({payload: {history}}) {
  try {
    const posIntegrationState = yield select(getPosIntegration);
    const posIntegration = posIntegrationState.posIntegration;
    const res = yield httpPost(POS_INTEGRATIONS_ENDPOINT, posIntegration);
    console.log(res);
    if (res.status !== 200) {
      yield put(apiError(res.data.error));
      errorToaster(res.data.error);
      return false;
    }

    yield put(emptyPosIntegration());
    history.push('/posIntegrations/list');
    successToaster('Record added.', 'Success');
  } catch (error) {
    yield put(apiError(error));
  }
}

function* deletePosIntegration({ payload: { id } }) {
  try {
    const res = yield httpDelete(`${POS_INTEGRATIONS_ENDPOINT}/${id}`);
    if (res.status !== 200) {
      yield put(apiError(res.data.error));
      return false;
    }
    console.log('shoud run');
    yield put(fetchPosIntegrations());
  } catch (error) {
    yield put(apiError(error));
  }
}

function* editPosIntegration({ payload: { id } }) {
  try {
    const res = yield httpGet(`${POS_INTEGRATIONS_ENDPOINT}/${id}`);
    if (res.status !== 200) {
      yield put(apiError(res.data.error));
      return false;
    }

    yield put(setPosIntegration({ field: 'pos_name', value: res.data.pos_name }));
    yield put(
      setPosIntegration({ field: 'description', value: res.data.description })
    );
  } catch (error) {
    yield put(apiError(error));
  }
}

function* updatePosIntegration({ payload: {history,  id } }) {
  try {
    const posIntegrationState = yield select(getPosIntegration);
    const posIntegration = posIntegrationState.posIntegration;
    const res = yield httpPut(`${POS_INTEGRATIONS_ENDPOINT}/${id}`, posIntegration);
    console.log(res);
    if (res.status !== 200) {
      yield put(apiError(res.data.error));
      return false;
    }

    yield put(emptyPosIntegration());
    history.push('/posIntegrations/list');
    successToaster('Record updated', 'Success');
  } catch (error) {
    yield put(apiError(error));
  }
}

const getPosIntegration = (state) => state.PosIntegration;

export function* watchGetPosIntegrations() {
  yield takeEvery(GET_POS_INTEGRATIONS, getPosIntegrations);
}

export function* watchGetPosIntegrationsList() {
  yield takeEvery(GET_POS_INTEGRATIONS_LIST, getPosIntegrationsList);
}

export function* watchAddPosIntegration() {
  yield takeEvery(ADD_POS_INTEGRATION, addPosIntegration);
}

export function* watchDeletePosIntegration() {
  yield takeEvery(DELETE_POS_INTEGRATION, deletePosIntegration);
}

export function* watchEditPosIntegration() {
  yield takeEvery(EDIT_POS_INTEGRATION, editPosIntegration);
}

export function* watchUpdatePosIntegration() {
  yield takeEvery(UPDATE_POS_INTEGRATION, updatePosIntegration);
}

function* posIntegrationSaga() {
  yield all([
    fork(watchGetPosIntegrations),
    fork(watchAddPosIntegration),
    fork(watchDeletePosIntegration),
    fork(watchEditPosIntegration),
    fork(watchUpdatePosIntegration),
    fork(watchGetPosIntegrationsList)
  ]);
}

export default posIntegrationSaga;
